import { useTranslation } from "react-i18next"
import { Text } from "@oysterhr/ui"
import { HowToSetupDDParagraph } from "../../../../components/HowToSetupDDParagraph"

interface BankDetailsAdvisorProps {
  step: number
}

const AdvisorContent = ({ step }: BankDetailsAdvisorProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchBankDetailsPearl")

  return step === 1 ? (
    <Text className="font-semibold">{t("confirmDepositAmounts.step1.paragraph1")}</Text>
  ) : (
    <Text className="font-semibold">{t("confirmDepositAmounts.step2.paragraph1")}</Text>
  )
}

export const BankDetailsAdvisor = ({ step }: BankDetailsAdvisorProps) => {
  return (
    <span className="text-base leading-normal text-black">
      <div>
        <AdvisorContent step={step} />
        <HowToSetupDDParagraph />
      </div>
    </span>
  )
}
